import { Component, OnInit, OnChanges, SimpleChanges, ɵConsole, TemplateRef, ViewChild } from "@angular/core";
import { VproService } from "./../../service/vpro/vpro.service";
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Appointment } from "../../models/appointment";
import { Physician } from "../../models/physician";
import { AllPatient } from "src/app/models/patient";
import { Timeoption } from "src/app/models/timeoption";

import {
  NgbDatepickerConfig,
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { DashCred } from "src/app/models/dash";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { sortBy } from "underscore";
import { FormArray, FormBuilder, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { DoctorCalendarComponent } from "src/app/component/doctor-calendar/doctor-calendar.component";
import { ActivatedRoute, Router } from "@angular/router";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});



import {
  EventEmitter,
  Input,
  Output,
  ElementRef,
} from "@angular/core";
import { PatientD } from '../../models/Pdetails';
import { Checkin } from 'src/app/models/scheckin';
declare var $: any;
declare var angular: any;
import { Location } from '@angular/common';

import { environment } from 'src/environments/environment';
import { any } from "underscore";
declare var $: any;
@Component({
  selector: 'app-patient-helath-stats-update',
  templateUrl: './patient-helath-stats-update.component.html',
  styleUrls: ['./patient-helath-stats-update.component.css']
})
export class PatientHelathStatsUpdateComponent implements OnInit {

  @ViewChild('PDFModal', { static: true } as any) PDFModal: TemplateRef<any>;

  pid: any;
  statslist: any = [];
  pat_stats: UntypedFormArray;

  testsList: any[];
  modalForm: any;
  report_attachments: UntypedFormArray;
  selectedLabTest = null;
  closeResult: string;
  reportsToBeUploaded: any = [];
  fileExtension: any = [];


  forms = {
    patstats: null,
  };

  forms_stats = {
    documentsForm_stats: null,
  };
  drid: any;
  pdfSrc1: any;
  pdfSrc: any;
  patient: AllPatient;

  constructor(

    private modalService: NgbModal,
    private location: Location,
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private service: VproService,
    private addPService: VproService,//new
    private fb: UntypedFormBuilder,//new
    private patService: VproService,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private checkinService: VproService
  ) {

    this.forms.patstats = this.fb.group({
      pat_stats: this.fb.array([]),
    });

    this.modalForm = this._formBuilder.group({
      remarks: [""],
      review: [""],
      testid: [""],
      tstat: [""],
      report_attachments: this._formBuilder.array([]),
    });



  }

  ngOnInit() {
    this.loadPatient();
    this.pid = this.route.snapshot.params["pid"];
    console.log("PID::", this.pid);

    this.drid = JSON.parse(localStorage.getItem('uid'))
    this.getStatsList(); //new
    this.fetchPreviousLabReports(this.pid);


  }
  goBack() {
    this.location.back();
  }

  loadPatient() {
    this.spinner.show();
    this.service.fetchPatientById(this.route.snapshot.params["pid"]).subscribe(
      (response) => {
        this.spinner.hide();
        if (response) {
          this.patient = response;
          console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^response.ppurl", this.patient.ppurl);
          console.log("this.patient", this.patient)
          this.patient.name = this.patient.first_name.trim() + ' ' + this.patient.last_name.trim();
          this.patient.avatarimg = this.patient.ppurl.substring(this.patient.ppurl.lastIndexOf('/') + 1);

        }
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }
  statuscheck() {
    this.savestats();
  }



  // Save Statistics

  savestats() {
    var pid, cid;
    var today = new Date();
    var date = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    var current_date = year + '-' + month + '-' + date;


    let data = {
      ...this.forms.patstats.value,
      //...this.forms.reasonForm.value, 
      //in above code array key is 'reasons' now we want toc hange 'reason'
      //we can use like this instead of the above line


    };


    if (data.pat_stats && data.pat_stats.length === 0) {
      delete data.pat_stats;
    }

    if (data.pat_stats && data.pat_stats.length > 0) {

      var stats_std_val;
      data.pat_stats.forEach((x, index) => {
        x.stats_std_val = x.stats_value;
        //x.aid = "000";
        x.pid = parseInt(this.pid);
        x.stats_date_time = current_date;
        x.stats_by = this.drid;

        delete x.stats_value;
      });
    }



    data.patient_checkin_stats = data.pat_stats;
    delete data.pat_stats;

    if (data.patient_checkin_stats && data.patient_checkin_stats.length === 0) {
      delete data.patient_checkin_stats;
    }

    console.log("DATA", data);
    this.spinner.show();
    this.service.saveCheckin_stats(data).subscribe(
      () => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "success",
          title: "Patient Medical Records added Success !",
        });

        this.goBack();
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }



  getStatsList() {
    this.spinner.show();
    this.service.getstatList().subscribe(
      (res) => {
        this.statslist = res
        console.log("this.statslist =", res);
        for (let stats of this.statslist) {
          this.pat_stats = this.forms.patstats.get(
            "pat_stats"
          ) as UntypedFormArray;
          this.pat_stats.push(this.addStats(stats.id));
        }
      },
      (error) => { }
    );
  }

  addStats(id): UntypedFormGroup {
    return this.fb.group({
      stats_id: [id],
      stats_value: [null],
    });
  }

  public getStatsLabel(i) {
    return this.statslist[i].stats_name;
  }


  public getStatsuom(i) {
    return this.statslist[i].stats_std_uom;
  }

  fetchPreviousLabReports(pidd) {
    this.spinner.show();
    this.service
      .fetchPatientTestsByPhysician({ pid: pidd, drid: this.drid })
      .subscribe((result) => {
        this.spinner.hide();
        this.testsList = result.reverse();
        let fileName, filen;
        for (var i = 0; i < this.testsList.length; i++) {
          filen = this.testsList[i].attachments;
          if (filen) {
            for (var j = 0; j < filen.length; j++) {
              var filenn = filen[j];
              if (filenn) {
                this.fileExtension.push(filen[j].split('?')[0].split('.').pop());
              }
            }
            this.testsList[i].attachments['ext'] = this.fileExtension;
            this.fileExtension = [];
          }
        }
      });
  }


  openEditLabTest(content, record) {
    this.modalForm.removeControl("report_attachments");
    this.modalForm.addControl(
      "report_attachments",
      this._formBuilder.array([])
    );
    this.report_attachments = this.modalForm.get(
      "report_attachments"
    ) as UntypedFormArray;

    if (record.attachments && record.attachments.length > 0) {
      record.attachments.forEach((attachment) => {
        this.report_attachments.push(
          this._formBuilder.group({
            s3Key: [attachment],
          })
        );
      });
    }
    this.modalForm.patchValue({
      testid: record.testid,
      review: record.review,
      remarks: record.remarks,
    });
    console.log(this.modalForm);
    this.selectedLabTest = record;
    this.modalService
      .open(content, { windowClass: "bloodTestModal" })
      .result.then(
        (result) => {
          this.selectedLabTest = null;
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.selectedLabTest = null;
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }


  uploadReports(files) {
    this.reportsToBeUploaded = [];
    if (files && files.length > 0) {

      Object.keys(files).forEach((key) => {
        if (key != "length") {
          this.reportsToBeUploaded.push(files[key]);
        }
      });
    }
    console.log("lllllllllllllllllllllllllllllll", this.reportsToBeUploaded);
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }


  updateLabTest(input) {
    input.tstat = "Captured";
    input.pid = this.pid
    console.log(input.pid);
    console.log("-----------------------------------------------")
    console.log(input);
    console.log(this.reportsToBeUploaded.length);
    if (this.reportsToBeUploaded.length == 0) {
      this.showToast('error', 'Choose file to upload');
      return null;
    }
    console.log(this.reportsToBeUploaded[0].name);
    input.org_code = localStorage.getItem("orgcode");
    input.attachments = this.reportsToBeUploaded.map((report) => {
      return { name: report.name, content_type: report.type };
    });
    input.existingKeys = input.report_attachments.map((item) =>
      item.s3Key.replace(`${environment.content_base_url}/`, "")
    );
    delete input.report_attachments;
    this.spinner.show();
    this.service
      .updateLabtest(this.pid, input, this.reportsToBeUploaded)
      .subscribe(() => {
        this.spinner.hide();
        this.showToast('success', "Record updated successfully");
        this.reportsToBeUploaded = [];
        this.fetchPreviousLabReports(this.pid);
      });
  }

  deleteAttachment(i) {
    this.report_attachments.removeAt(i);
  }

  closeModal() {
    this.modal.dismissAll();
  }

  // Preview document fetch function
  async previewDocuments(doc: any) {
    let uri = environment.content_base_url + "/" + doc;
    if (Utils.allowedImageFormats.includes(doc.split('.').pop())) {
      Swal.fire({
        imageUrl: doc,
        showConfirmButton: false,
        showCloseButton: true,
      })
    } else {

      this.pdfSrc1 = doc;
      console.log(this.pdfSrc1);
      const files = { name: doc.name, type: doc.type };
      this.pdfSrc = doc;

      this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });

    }
    // }
  }
  // Preview Docs on round image
  imgSrc: string;

  onClick(event) {
    const imgElem = event.target;

    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.imgSrc = srcAttr.nodeValue;

    //console.log(event);
    // console.log(event.srcElement);
    // console.log(event.currentTarget);
    // console.log(srcAttr);
    // console.log(this.imgSrc);
  }

}